// src/app/state/app-state.token.ts

import { AppState } from './app-state.model';
import { InjectionToken } from '@angular/core';

export const INITIAL_APP_STATE = new InjectionToken<AppState>(
  'Initial App State',
  {
    providedIn: 'root',
    factory: () => ({
      accessToken: null,
    }),
  }
);
